<template>
   <div class='chart-container' ref="container" >
      <highcharts :options="chartOptions" ref='highcharts'/>
   </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import exportingInit from "highcharts/modules/exporting";

exportingInit(Highcharts);

export default {
   name: "highchart-chart",
   components: {
      highcharts: Chart,
   },
   mounted()
   {
      const { container, highcharts: { chart } } = this.$refs;
      let timeout = null;
      this.setHeight = () =>
      {
         clearTimeout(timeout);
         timeout = setTimeout(() => {
            if (chart && container && container.offsetWidth)
            {
               const isFullScreen = container.firstChild.offsetWidth === document.body.offsetWidth;
               const {offsetWidth,offsetHeight} = isFullScreen ?
                  {offsetWidth: window.innerWidth, offsetHeight: window.innerHeight } // if we use document's width, goes outside sometimes
                  :
                  container;
               chart.setSize(offsetWidth, offsetHeight, {duration:0});
               chart.yAxis[0].isDirty = true;
               chart.redraw();
            }
         }, 500);
      }
      
      window.addEventListener('resize', this.setHeight);
      this.updateChart(this.chartData);
      this.setHeight();
   },
   beforeDestroy()
   {
      window.removeEventListener('resize', this.setHeight);
   },
   props: {
      chartData: {
         type: Object,
         required: true,
         validator: data => {
            return (
               data.title &&
               data.xAxis && data.xAxis instanceof Object &&
               data.yAxis && data.yAxis instanceof Object && 
               data.series && data.series instanceof Array
            );
         },
      }
   },
   watch: {
      chartData(newValue)
      {
         this.updateChart(newValue);
      }
   },
   data() {
      return {
         setHeight: null,
         chartOptions: {
            credits: {
               enabled: false,
            },
            tooltip: {
               shared: true
            },
            legend: {
               align: 'center',
               verticalAlign: 'bottom',
               y: 0,
               padding: 0,
               itemMarginTop: 0,
               itemMarginBottom: 0,
               itemStyle: {
                  lineHeight: '0px'
               }
            },
         },
      };
   },
   methods: {
      updateChart(newChartData)
      {
         const tooltip = newChartData.tooltip || {};
         const getStyledAxis = (axisInfo) =>
         {
            if (Array.isArray(axisInfo))
               return axisInfo.map(axis => ({...axis, className: 'highchart-axis-style'}));

            return  {...axisInfo, className: 'highchart-axis-style'};
         };
   
         this.$refs.highcharts.chart.update({
            ...newChartData,
            tooltip: {
               shared: true,
               ...tooltip,
            },
            xAxis: getStyledAxis(newChartData.xAxis),
            yAxis: getStyledAxis(newChartData.yAxis),
         }, true, true);
      }
   },
}
</script>

<style lang="scss">
.chart-container {
   height: 100%;
   width: 100%;
   border-radius: 0.3em;
   overflow: hidden;
   
   * {
      font-family: $secondary-font;
   }
}


.highcharts-title tspan {
   font-size: 0.9em;
   margin-top: 0.3em;
   font-weight: 500;
}

.energy-charts .highcharts-title tspan {
   font-size: 0.8em;
}

.highchart-axis-style text,
.highchart-axis-style tspan {
   fill: lighten($dark-color, 15%);
   font-weight: 500;
   font-size: 1em;
}
</style>